<div class="navblock hidden-print">
  <div class="btn_tabs">
    <!--button (click)="openTab('status')" [class.active]="isSelected('status')">{{"Status"|translate}}</button-->
    <button (click)="openTab('settings')" [class.active]="isSelected('settings')">{{"Settings"|translate}}</button>
  </div>
  <div></div>
  <button class="btn_blue" (click)="Apply()">{{'Apply'|translate }}</button>
</div>

<div class="tablewrap" *ngIf="isSelected('status')" id="main">
  <app-server-status></app-server-status>
</div>
<div class="tablewrap" *ngIf="isSelected('settings')" id="main">
  <app-server-settings [apply]="this.apply.asObservable()"></app-server-settings>
</div>


<app-pagination [viewmode]="'print'"></app-pagination>
